const swipperWrapper = document.querySelector('.swiper-wrapper');
const swipperTextList = document.getElementsByClassName('mm-swipper-card-text_left');

const swiper = new Swiper(".swiper", {
    // Optional parameters
    direction: "horizontal",
    effect: "cards",
    grabCursor: true,

    // If we need pagination
    pagination: {
        el: ".swiper-pagination",
    },

    // Navigation arrows
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
});

swiper.on("transitionEnd", function () {
    var activeSlideClassName = swipperWrapper.getElementsByClassName("swiper-slide-active")[0].classList[0];
    activeSlideClassName = activeSlideClassName.replace("mm-swiper-slide-", "");
    for (let i = 0; i < swipperTextList.length; i++) {
        if (swipperTextList[i].className.includes(activeSlideClassName)) {
            swipperTextList[i].classList.add("active");
        } else {
            swipperTextList[i].classList.remove("active");
        }
    }
});
